import { Component } from '@angular/core';
import { KeysPipe} from '../../utils/keys.pipe';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-device-dynamic',
  templateUrl: './device-dynamic.component.html',
  styleUrls: ['./device-dynamic.component.css']
})



export class DeviceDynamicComponent {

   device:any = {
    "id": 205238,
    "serialnumber": "80658165",
    "parent": "2085",
    "model": "detector",
    "token": "a94a24cb962ed4f60055d37807a8c96cb39c904e",
    "lost_timeout": 1800,
    "lost": true,
    "fwrev": {
      "wm": "",
      "net": "",
      "alarm": ""
    },
    "hwrev": "",
    "errors": [],
    "life": 535,
    "battvolt": null,
    "battery": null,
    "smoke": {
      "alarm": false,
      "level": 0,
      "comp": -1,
      "too_much_smoke": false,
      "hushed": false
    },
    "co": {
      "alarm": false,
      "level": 1
    },
    "temperature": {
      "value": 79
    },
    "hardwire_smoke": false,
    "hardwire_co": false,
    "ptt_active": false,
    "locate_active": false,
    "identifying": false,
    "notify_eol": true,
    "notify_contact": true,
    "last_test_time": null
  };

}
